import styled from 'styled-components';

export const QtyInputContainer = styled.div`
  margin-top: -2rem;
`;
